import React from "react";

export default function ZPartner01GrabHeader() {
    return (
        <header className="header-main shadow-sm">
            <nav id="navbar_top" className="navbar navbar-expand-md bg-white">
                <div className="container">
                    <a href="#" className="navbar-brand col-2 col-md-1 pe-0 me-0" id="logo">
                        <img src="media/starbucks_corporation_logo.png" alt="Starbucks" className="img-fluid" />
                    </a>
                    Grab
                </div>
            </nav>
        </header>
    );
}
